import { IApplicationState } from '../../types/redux';

export function hasNewbuildingMVK({ newbuildingMVK }: IApplicationState): boolean {
  return !!newbuildingMVK;
}
